import { AppliedFilterBarOpt, FilterBarInputOpt, FilterGroup, IFilterBar } from "../../../models/utilities/filter-bar";
import { ListColumn, SelectedSort } from "../../../models/utilities/list-header";
import { PageData } from "../../../models/utilities/paged-request";
import { ApiEndpoints } from "../../../utils/app-constants";

/**
 * The search for the orders waiting on a customer service review.
 */
export class CustomerServiceSearchFilters implements IFilterBar {

    public paginationInfo: PageData = new PageData(10000);
    public baseUrl: string = ApiEndpoints.ORDERING_CUSTOMER_SERVICE_REVIEW;
    public filters: FilterGroup[] = [];
    public appliedFilters: AppliedFilterBarOpt[] = [];
    public requiredFilters: AppliedFilterBarOpt[] = [];
    public columns: ListColumn[];
    public selectedSort: SelectedSort;

    constructor() {

        // Set our table columns
        this.columns = [
            new ListColumn('Order Id', 'orderId', false),
            new ListColumn('Description', 'description', false),
            new ListColumn('Cutoff', 'cutoffDate', false),
        ];

        // Create our Filter Groups
        const byCutoff = this.buildCutoff();
        const byOrder = this.buildOrder();

        this.filters.push(
            byCutoff, byOrder
        );

    }

    // #region Group Builders
    private buildCutoff() {
        const byDate = new FilterGroup('Cutoff', 'dateplus', 'maxCutoff');
        const opt1 = new FilterBarInputOpt('Cutoff', {
            selectedDate: {
                qsValue: new Date(),
                qsName: 'maxCutoff'
            },
            checkboxValue: {
                qsValue: false,
                qsName: 'matchDayOfWeek'
            }
        });

        byDate.opts = [opt1];

        return byDate;
    }

    private buildOrder() {
        const byOrderId = new FilterGroup('Order ID', 'text', 'orderId');
        const opt1 = new FilterBarInputOpt('Order ID', '');

        byOrderId.opts = [opt1];

        return byOrderId;
    }

    // #endregion

}
